import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CampaignWinners from '@/components/v2/CampaignWinners';
import PageTitle from '@/components/v2/PageTitle.vue';
import SurveyTaskRespondentDetails from '@/components/v2/SurveyTaskRespondentDetails.vue';
import Paginator from '@/components/v2/Paginator.vue';
import RouterParamsAppMixin from '../../../helpers/vue_mixins/RouterParamsAppMixin';
let Winner = class Winner extends mixins(RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.activeWinner = null;
    }
    get headers() {
        const defaultHeaderConfig = {
            align: 'left',
            sortable: false,
        };
        return [
            { text: 'USER', value: 'user', ...defaultHeaderConfig },
            { text: 'CAMPAIGN NAME', value: 'campaignName', ...defaultHeaderConfig },
            { text: 'DATE OF WINNING', value: 'winningDate', ...defaultHeaderConfig },
            { text: 'PRIZE', value: 'prize', ...defaultHeaderConfig },
        ];
    }
    setWinner(campaignWinner) {
        this.activeWinner = campaignWinner.winner;
    }
};
Winner = __decorate([
    Component({
        components: {
            PageTitle,
            SurveyTaskRespondentDetails,
            CampaignWinners,
            Paginator,
        },
    })
], Winner);
export default Winner;
